import ProductSystemPdfImageOverride from '@/models/ProductSystemPdfImageOverride';

export default class ProductSystemPdfImageOverrideRepository {
    public static getAll(): ProductSystemPdfImageOverride[] {
        return ProductSystemPdfImageOverride.all();
    }

    public static getById(id: string): ProductSystemPdfImageOverride | null {
        return ProductSystemPdfImageOverride.find(id);
    }

    public static getByProductSystemId(productSystemId: string): ProductSystemPdfImageOverride[] {
        return ProductSystemPdfImageOverride.query().where('productSystem_id', productSystemId).get();
    }
}
